import { render, staticRenderFns } from "./feeListByBatch.vue?vue&type=template&id=b354b77a&scoped=true&lang=html&"
import script from "./feeListByBatch.vue?vue&type=script&lang=js&"
export * from "./feeListByBatch.vue?vue&type=script&lang=js&"
import style0 from "./feeListByBatch.vue?vue&type=style&index=0&id=b354b77a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b354b77a",
  null
  
)

export default component.exports